/**
 * The front end's own build info, embedded by vite-plugin.ts as the global __PCB_ABOUT_BUILD__.
 * Returns null when the plugin did not run (unit tests, a misconfigured build) so the About view
 * says so instead of showing nothing.
 */

import type { FrontendBuildInfo } from './types';

declare const __PCB_ABOUT_BUILD__: FrontendBuildInfo | undefined;

export function getBuildInfo(): FrontendBuildInfo | null {
  try {
    return typeof __PCB_ABOUT_BUILD__ !== 'undefined' ? __PCB_ABOUT_BUILD__ : null;
  } catch {
    return null;
  }
}
